(function ($) {
	$(document).ready(function () {

		// For each slider in each Feature Slider block.
		$.each($('.feature-slider-block'), function () {
			let slider_block_id = $(this).attr('id');

			$.each($('.feature-slider-container', $(this)), function () {
				let carousel_object = $(this);
				let carousel_id = carousel_object.attr('data-slider-id');
				let slider_group_id = carousel_object.attr('data-slider-group-id');

				// Initialize Slick.
				$(carousel_object).slick(
					'slickSetOption',
					{
						infinite: false,
						variableWidth: true,
						slidesToShow: 4,
						responsive: [
							{
								breakpoint: 1600,
								settings: {
									infinite: false,
									variableWidth: false,
									slidesToShow: 4,
								}
							},
							{
								breakpoint: 1400,
								settings: {
									infinite: false,
									variableWidth: false,
									slidesToShow: 3,
								}
							},
							{
								breakpoint: 1199,
								settings: {
									infinite: false,
									variableWidth: false,
									slidesToShow: 2,
								}
							},
							{
								breakpoint: 992,
								settings: {
									infinite: false,
									variableWidth: false,
									slidesToShow: 2,
								}
							},
							{
								breakpoint: 767,
								settings: {
									infinite: false,
									variableWidth: false,
									slidesToShow: 2,
								}
							},
							{
								breakpoint: 576,
								settings: {
									infinite: false,
									variableWidth: false,
									slidesToShow: 1,
								}
							},
						]
					},
					true
				);

			});

		});
	});

})(jQuery);